var v = Object.defineProperty, b = (r, t, a) => t in r ? v(r, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : r[t] = a, n = (r, t, a) => (b(r, typeof t != "symbol" ? t + "" : t, a), a);
class o {
}
n(o, "getGroupCategory", (r) => r.category_info.group ?? r.category);
n(o, "getPrimaryCategory", (r) => {
  var t;
  return ((t = r.category_info) == null ? void 0 : t.primary) ?? r.category;
});
n(o, "getSubCategory", (r) => r.category_info.sub_category ?? (r == null ? void 0 : r.sub_category));
const C = ({ categoriesIconData: r, info: t }) => {
  var a, u;
  const i = t && o.getGroupCategory(t), c = t ? o.getPrimaryCategory(t) : void 0, d = t ? o.getSubCategory(t) : void 0, l = r.find((e) => e.label === i), s = r.flatMap((e) => e.children), g = (a = (l == null ? void 0 : l.children) || s) == null ? void 0 : a.find(
    (e) => (e == null ? void 0 : e.label) === c
  ), y = (u = g == null ? void 0 : g.children) == null ? void 0 : u.find((e) => e.label === d);
  return (y == null ? void 0 : y.path) || (g == null ? void 0 : g.path) || (l == null ? void 0 : l.path);
};
export {
  o as PlacePOI,
  C as getCategoryPathIcons
};
//# sourceMappingURL=index.es175.js.map
